export default "__VITE_ASSET__D4eejQzE__"